import CoreUtils from '../utils/CoreUtils';

import EnergyValueUtils from './EnergyValueUtils';

export default class EnergyValueMask {
  constructor(maskValue) {
    if (EnergyValueUtils.isValidMaskValue(maskValue))
      this.maskValues = [maskValue];
    else if (EnergyValueUtils.isValidMaskValueArray(maskValue))
      this.maskValues = EnergyValueUtils.normalizeValues(maskValue);
    else
      this.maskValues = [false];

    this.resolution = this.maskValues.length;

    this.all = this.maskValues.every(maskValue => maskValue);
    this.any = this.maskValues.some(maskValue => maskValue);
    this.none = this.maskValues.every(maskValue => !maskValue);

    Object.freeze(this);
  }

  inverse() {
	  return new EnergyValueMask(
      this.maskValues.map(maskValue => !maskValue)
    );
  }

  and(energyValueMask, maximumResolution) {
    return new EnergyValueMask(
      EnergyValueUtils.intersect(
        this.maskValues,
        energyValueMask.maskValues,
        (value1, value2) => value1 && value2,
        maximumResolution
      )
    );
  }

  or(energyValueMask, maximumResolution) {
    return new EnergyValueMask(
      EnergyValueUtils.intersect(
        this.maskValues,
        energyValueMask.maskValues,
        (value1, value2) => value1 || value2,
        maximumResolution
      )
    );
  }

  equals(energyValueMask) {
    if (CoreUtils.isUndefinedOrNull(energyValueMask))
      return false;

    if (!(energyValueMask instanceof EnergyValueMask))
      return false;

    if (energyValueMask.maskValues.length !== this.maskValues.length)
      return false;

    for (var index = 0; index < this.maskValues.length; index++) {
      if (this.maskValues[index] !== energyValueMask.maskValues[index])
        return false;
    }

    return true;
  }
}